export const truncateChatTitle = (title: string, maxLength: number = 20): string =>
    title.length > maxLength ? title.slice(0, maxLength) + "..." : title;
  
export const formatDate = (): string => {
  const now = new Date();
  return now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
};

/**
 * Форматирует ошибки API в читаемую строку
 * Обрабатывает как простые строки, так и validation errors от FastAPI
 */
export const formatApiError = (error: any): string => {
  // Если это уже строка
  if (typeof error === 'string') {
    return error;
  }
  
  // Если это массив validation errors от FastAPI
  if (Array.isArray(error)) {
    return error.map(err => {
      const field = err.loc ? err.loc.join('.') : 'unknown';
      return `${field}: ${err.msg}`;
    }).join(', ');
  }
  
  // Если это объект с полем detail
  if (error?.detail) {
    return formatApiError(error.detail);
  }
  
  // Fallback
  return 'Si è verificato un errore';
};